import options from './autocomplete.component';

export default {
    selector: 'dtSearchAutocomplete',
    options
};
